import { ReportProfileAlertResourcesBaseModel } from '../report-profile-alert-resources-base-model';

export class ReportProfileAlertResourceNotBelongToMeModel extends ReportProfileAlertResourcesBaseModel {
  userId: string|null;
}
